import { GET_PRODUCTS, ADD_PRODUCT, UPDATE_PRODUCT, UPDATE_PRODUCT_QUANTITIES } from 'redux/actionTypes';

export default function products(state = [], action) {
    switch(action.type) {
        case GET_PRODUCTS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_PRODUCT:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_PRODUCT:
            const index = state.findIndex(product => product.id === action.payload.id);
            return [
                ...state.slice(0, index),
                action.payload,
                ...state.slice(index + 1)
            ];
        case UPDATE_PRODUCT_QUANTITIES:
            return state.map(product => {
                const update = action.payload.find(updatedProduct => updatedProduct.id === product.id);
                return update ? {
                    ...product,
                    quantity: update.quantity
                } : product;
            });
        default:
            return state;
    }
};